export function formatHallCount(count: number): string {
  if (count <= 1) return '';

  const units = [
    '',
    'одном',
    'двух',
    'трёх',
    'четырёх',
    'пяти',
    'шести',
    'семи',
    'восьми',
    'девяти',
  ];
  const teens = [
    'десяти',
    'одиннадцати',
    'двенадцати',
    'тринадцати',
    'четырнадцати',
    'пятнадцати',
    'шестнадцати',
    'семнадцати',
    'восемнадцати',
    'девятнадцати',
  ];
  const tens = [
    '',
    '',
    'двадцати',
    'тридцати',
    'сорока',
    'пятидесяти',
    'шестидесяти',
    'семидесяти',
    'восьмидесяти',
    'девяноста',
  ];
  const hundreds = [
    '',
    'ста',
    'двухстах',
    'трёхстах',
    'четырёхстах',
    'пятистах',
    'шестистах',
    'семистах',
    'восьмистах',
    'девятистах',
  ];
  const remainder = count % 100;
  const words =
    count < 1000
      ? [
          hundreds[Math.floor(count / 100)],
          remainder >= 10 && remainder < 20
            ? teens[remainder - 10]
            : tens[Math.floor(remainder / 10)],
          remainder >= 10 && remainder < 20 ? '' : units[remainder % 10],
        ]
          .filter(Boolean)
          .join(' ')
      : String(count);
  const hallWord = count % 10 === 1 && remainder !== 11 ? 'зале' : 'залах';
  return `в ${words} ${hallWord}`;
}
